import React from "react";
import styles from "./WorkspaceLoading.module.css";

type WorkspaceLoadingProps = {
  title?: string;
  message?: string;
};

const WorkspaceLoading = ({
  title = "Loading your workspace...",
  message = "We're checking your profile and tenant access.",
}: WorkspaceLoadingProps) => (
  <div className={styles["workspace-loading-shell"]} role="status" aria-live="polite">
    <div className={styles["workspace-loading-card"]}>
      <div className={styles["workspace-loading-card-header"]}>
        <h1 className={styles["workspace-loading-title"]}>{title}</h1>
      </div>
      <div className={styles["workspace-loading-card-body"]}>
        <div className={styles["workspace-loading-spinner"]} aria-hidden="true" />
        <p className={styles["workspace-loading-message"]}>{message}</p>
      </div>
    </div>
  </div>
);

export default WorkspaceLoading;
